import ApiService from './';

/**
* @heading1: Authentication API Service
 *
 * @paragraph: This module provides a set of methods to interact with the Authentication API.
 * It handles operations like user login, signup, and logout.
 */

const SubscriptionApi = {
    getPlans: (token: string) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({ url: 'get-plan', token, method: 'post' });
    },
    checkoutPlan: (token: string, plan_id: number) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'create-checkout-session',
            token,
            method: 'post',
            data: { plan_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    cancelSubscription: (token: string) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'cancel-subscription',
            token,
            method: 'post',
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    changePlan: (token: string, plan_id: number) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'switch-subscription-plan',
            token,
            method: 'post',
            data: { plan_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchProratedCharge: (token: string, plan_id: number) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'get-prorate-charges',
            token,
            method: 'post',
            data: { plan_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchCurrentPlanDetails: (token: string) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'get-subscription-details',
            token,
            method: 'post',
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    specialUpgradePlan: (token: string) => {
        // Perform a POST request to the logout endpoint with the authentication token
        return ApiService.apiHit({
            url: 'special-upgrade-plan',
            token,
            method: 'post',
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default SubscriptionApi;
